 

import React, { Component } from "react";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { withRouter } from "react-router-dom";
import SECard from "../components/secard";
import SENews from "../components/newscard";
import ApiSession from "../api/ApiSession";
import Pagination from "react-js-pagination";
import UserManagement from "./userManagement";
import GlobalParametersHook from "./GlobalParametersHooks";
import LibraryManagementHook from "./LibraryManagementHook";
import Analytics from "./analytics";
import FileDownload from "js-file-download";
import Onboarding from "react-onboarding-pro";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-onboarding-pro/build/index.css";
import "react-circular-progressbar/dist/styles.css";
import Dsc from "./dsc";
import { ProjectConst } from "../utils/constants";
import { ResetJotai } from "./CustomHooks/ResetJotai";
import Help from "./Help";
import { sendCallToActionEvent, sendCommonEvent, sendNavClickEvent, sendPageViewEvent } from "../utils/gaHelper";
import userScope from "./CustomHooks/userScope";

const {
  Create_Project,
  Reset_Filters,
  Please_Wait,
  steps,
  Not_Authorized,
  Error_copy,
  Error_delete,
  defaultProject
} = ProjectConst;
const config = {
  steps,
  overlayClose: false,
};

const apiSession = new ApiSession();

const TAB_TITLES = {
  projects: "Projects",
  user: "User Management",
  asset: "Library Management",
  globalparam: "Global Parameters",
  analytics: "Analytics",
  dsc: "Dsc",
  help: "Help"
};


export class ProjectHome extends Component {
  constructor(props) {
    let userSampleData = {
      name: "",
      role: "",
      access: {},
    };
    super(props);
    this.state = {
      notificationShow: false,
      key:
        sessionStorage.getItem("selectedtab") !== null
          ? sessionStorage.getItem("selectedtab")
          : "projects",
      searchInput: "",
      searchQ2cInput: "",

      loading: false,
      projectTypeFilter: "all",
      projectStatusFilter: "all",
      projects: [],
      projectsData: [],
      projectTotalCount: 0,
      activePage: 1,
      itemSliceFirst: 0,
      itemSliceLast: 5,
      itemsPerPage: 5,
      filtersApplied: false,
      totalFilteredCount: 0,
      type: "",
      message: "",
      userScope:
        JSON.parse(localStorage.getItem("scope")) !== null
          ? JSON.parse(localStorage.getItem("scope"))
          : userSampleData,
      deleteProjectConfirmPopUpStatus: false,
      deleteProjectId: null,
      deleteProjectName: "",
      emaWebsiteName: "",
      deleteSiteStatus: false,
      projectSite: false,
      newsList: [],
      pageLength: 30,
      deleteProjectConfirmSitePopUpStatus: false,
      confirmSiteDeletion: false,
      userImages: {},
      copyProjectConfirmPopUpStatus: false,
      copyProjectId: null,
      copyProjectName: "",
      copyProjectSiteName: "",
      projectPercentageLoaded: 0,
      displayProjectPercentage: true,
      createProjectPopupStatus: false,
      createProject: defaultProject,
      projectTypes: {},
      notificationData:{}
    };
    this.projectLoadRequestId = 0;
    this.projectLoadRequests = new Set();
    this.isProjectPageMounted = false;
    this.searchDebounceTimer = null;
  }

  debounceSearch = (callback, delay = 500) => {
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(callback, delay);
  };

  trackProjectRequest = (request) => {
    if (request && typeof request.cancel === "function") {
      this.projectLoadRequests.add(request);
      request
        .then(() => {
          this.projectLoadRequests.delete(request);
        })
        .catch(() => {
          this.projectLoadRequests.delete(request);
        });
    }
    return request;
  };

  cancelProjectLoadRequests = () => {
    this.projectLoadRequests.forEach((request) => {
      if (request && typeof request.cancel === "function") {
        request.cancel("Project page unmounted");
      }
    });
    this.projectLoadRequests.clear();
  };

  handleSearchInput = (e) => {
    this.setState({sortProjectOption: "0"});
    const search = e.target.value;
    this.setState({
      [e.target.name]: search,
    });
    
    // Only call API if search has 4+ characters or is empty
    if (search.length >= 4 || search.length === 0) {
      this.debounceSearch(() => {
        this.applyFilters(search, this.state.projectTypeFilter, this.state.projectStatusFilter);
      });
    }
  };
  checkUserFilter(users, search) {
    users?.filter((user) => {
      return user.firstName !== "" && user.firstName !== null
        ? user.firstName.toLowerCase().indexOf(search.toLowerCase()) !== -1
          ? true
          : false
        : true;
    });
  }

  resetProjectList() {
    this.setState({ 
      projects: this.state.projectsData,
      searchInput: "",
      projectTypeFilter: "",
      projectStatusFilter: "",
      activePage: 1,
      itemSliceFirst: 0,
      itemSliceLast: this.state.itemsPerPage,
      filtersApplied: false
    });
  }

  async downloadProjects() {
    try {
      this.setState({ loading: true });
      const response = await apiSession.downloadProjects(
        this.state.searchInput,
        this.state.projectStatusFilter,
        this.state.projectTypeFilter
      );
      FileDownload(response, "emb_projects.pdf", "application/pdf");
      if (response) {
        this.setState({ loading: false });
        this.callSnackbar("success", "Projects downloaded successfully");
      }
    } catch (error) {
      this.callSnackbar("error", "Error downloading projects");
    }
  }


  onButtonClick() {
    sessionStorage.setItem("projectId", null);
    sessionStorage.setItem("pname", null);
    if (this.state.userScope.access.saveProjects === true) {
      // let { history } = this.props;
      // history.push({
      //   pathname: "/information",
      // });

      apiSession
        .getProjectTypes()
        .then((json) => {
          this.setState({ projectTypes: json });
        })
        .catch((err) => {
          // Do Nothing
        });

      this.setState({
        createProjectPopupStatus: true,
      });
    } else {
      this.callSnackbar("error", Not_Authorized);
    }
  }
 onResetFilters(){
    this.setState({ projectTypeFilter: "" });
    this.setState({ projectStatusFilter: "" });
    this.applyFilters(this.state.searchInput, "", "");
 }
  openProject(projectId, projectName, deploymentReady, projectType) {
    if (this.state.userScope.access.openProject === true) {
      let { history } = this.props;
      sessionStorage.setItem("projectId", projectId);
      sessionStorage.setItem("pname", projectName);
      sessionStorage.setItem("projectKindType", projectType);
      sessionStorage.setItem("informationUpdateAvailable",false);
      sessionStorage.setItem("dersUpdateAvailable",false);
      sessionStorage.setItem("systemUpdatesAvailable",false);
      sessionStorage.setItem("deploymentReady", deploymentReady);
      history.push({
        pathname: `${"/information"}/${projectId}`,
      });
    }
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    if (this.state.filtersApplied) {
      this.getPageProjects(pageNumber);
    } else {
      this.getInitialPageProjects(pageNumber);
    }
  }

  getInitialPageProjects = async(pageNumber) => {
    try {
      this.setState({ loading: true });
      const page = pageNumber - 1;
      
      let response = await this.trackProjectRequest(
        apiSession.getProjectList(page, this.state.itemsPerPage)
      );
      
      let pageProjects = response.projects || [];
      const nextTotalCount = response.projectCount || this.state.projectTotalCount;
      
      this.setState({ 
        projects: pageProjects,
        projectTotalCount: nextTotalCount,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      this.callSnackbar("error", "Error loading projects");
    }
  };

  onChangeProjectTypeFilter = (e) => {
    this.setState({sortProjectOption: "0"});
    this.setState({ projectTypeFilter: e.target.value });
    this.applyFilters(this.state.searchInput, e.target.value, this.state.projectStatusFilter);
  };

  onChangeProjectStatusFilter = (e) => {
    this.setState({sortProjectOption: "0"});
    this.setState({ projectStatusFilter: e.target.value });
    this.applyFilters(this.state.searchInput, this.state.projectTypeFilter, e.target.value);
  };

  getPageProjects = async(pageNumber) => {
    try {
      this.setState({ loading: true });
      const projectStatus = this.state.projectStatusFilter || "";
      const projectType = this.state.projectTypeFilter || "";
      const page = pageNumber - 1;
      
      let response = await apiSession.getFilteredProjectList(
        this.state.searchInput,
        projectStatus,
        projectType,
        page,
        this.state.itemsPerPage
      );
      
      // Handle both array and object responses
      let pageProjects = Array.isArray(response)
        ? response
        : response.projects || [];
      pageProjects = pageProjects.slice(0, this.state.itemsPerPage);
      let totalCount = (response.projectCount || response.count) || this.state.totalFilteredCount;
      
      this.setState({ 
        projects: pageProjects,
        totalFilteredCount: totalCount,
        loading: false
      });
    } catch (error) {
      this.setState({ loading: false });
      this.callSnackbar("error", "Error loading projects");
    }
  };

  applyFilters = async(searchTerm ="", projectType ="all", projectStatus="all") => {
    this.projectLoadRequestId = 0;
    this.cancelProjectLoadRequests();
    try {
      this.setState({ loading: true, filtersApplied: true });
      let response = await apiSession.getFilteredProjectList(
        searchTerm,
        projectStatus,
        projectType,
        0,
        this.state.itemsPerPage
      );
      
      // Handle both array and object responses
      let filteredProjects = Array.isArray(response)
        ? response
        : response.projects || [];
      const fallbackFilteredCount = filteredProjects.length;
      filteredProjects = filteredProjects.slice(0, this.state.itemsPerPage);
      let totalCount =
        response.projectCount || response.count || fallbackFilteredCount;
      
      this.setState({ 
        projects: filteredProjects,
        totalFilteredCount: totalCount,
        loading: false,
        activePage: 1
      });
    } catch (error) {
      this.setState({ loading: false });
      this.callSnackbar("error", "Error applying filters");
    }
  };
  onChangeSortOption = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });

    if (e.target.value) {
      let projectListData = Object.assign([], this.state.projects);
      switch (e.target.value) {
        case "1":
          projectListData.sort(function (a, b) {
            var projectNameA = a.projectName.toLowerCase(),
              projectNameB = b.projectName.toLowerCase();
            if (projectNameA < projectNameB)
              //sort string ascending
              return -1;
            if (projectNameA > projectNameB) return 1;
            return 0;
          });
          break;
        case "2":
          projectListData.sort(function (a, b) {
            var projectNameA = a.projectName.toLowerCase(),
              projectNameB = b.projectName.toLowerCase();
            if (projectNameA > projectNameB)
              //sort string desc
              return -1;
            if (projectNameA < projectNameB) return 1;
            return 0;
          });
          break;
        case "3":
          projectListData.sort(function (a, b) {
            var dateA = new Date(a.lastModificationDate),
              dateB = new Date(b.lastModificationDate);
            return dateA - dateB; //sort by date ascending
          });
          break;
        case "4":
          projectListData.sort(function (a, b) {
            var dateA = new Date(a.lastModificationDate),
              dateB = new Date(b.lastModificationDate);
            return dateB - dateA; //sort by date desc
          });
          break;

        case "5":
          projectListData.sort((a, b) => {
            return b.favourite - a.favourite;
          });
          break;
        default:
          break;
      }
      this.setState({ projects: projectListData });
      this.setState({ activePage: 1 });
      this.setState({ itemSliceFirst: 0 });
      this.setState({ itemSliceLast: this.state.itemsPerPage });
    }
  };
  componentDidMount() {
    this.isProjectPageMounted = true;
    this.loadProject();
    this.getNews();
    this.getNotification();
    sessionStorage.setItem("assetEditStatus", "");
    sessionStorage.setItem("projectType", null);
    sessionStorage.setItem("projectKindType",null)
    
  }

  componentWillUnmount() {
    this.isProjectPageMounted = false;
    this.projectLoadRequestId = 0;
    this.cancelProjectLoadRequests();
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
  }

  async loadProject() {
    if (!this.isProjectPageMounted) {
      return;
    }
    const requestId = Date.now();
    this.projectLoadRequestId = requestId;
    sessionStorage.setItem("projectId", null);
    sessionStorage.setItem("pname", null);
    this.setState({ loading: true });
    
    try {
      const firstPageRequest = this.trackProjectRequest(
        apiSession.getProjectList(0, this.state.itemsPerPage)
      );
      const json = await firstPageRequest;
      if (!this.isProjectPageMounted || this.projectLoadRequestId !== requestId) {
        return;
      }

      const projects = json.projects || [];
      const projectTotalCount = json.projectCount || 0;
      const userImages = json.userImages || {};
      const projectPercentageLoaded = projectTotalCount
        ? Math.round((projects.length / projectTotalCount) * 100)
        : 100;

      this.setState({
        projects,
        projectsData: projects,
        projectTotalCount,
        userImages,
        loading: false,
        projectPercentageLoaded,
        displayProjectPercentage: projectPercentageLoaded !== 100,
      });
    } catch (error) {
      if (this.isProjectPageMounted && this.projectLoadRequestId === requestId) {
        this.setState({ loading: false });
      }
    }
  }

  async getProjectLoop(page, count, requestId, totalCount) {
    if (!this.isProjectPageMounted || this.projectLoadRequestId !== requestId) {
      return;
    }
    try {
      const pageRequest = this.trackProjectRequest(
        apiSession.getProjectList(page, count)
      );
      const json = await pageRequest;
      if (!this.isProjectPageMounted || this.projectLoadRequestId !== requestId) {
        return;
      }

      this.setState((prevState) => {
        const nextProjects = [...prevState.projects, ...(json.projects || [])];
        const nextProjectsData = [
          ...prevState.projectsData,
          ...(json.projects || []),
        ];
        const nextUserImages = {
          ...prevState.userImages,
          ...(json.userImages || {}),
        };

        const denominator = totalCount || json.projectCount || nextProjectsData.length;
        const projectPercentageLoaded = denominator
          ? Math.min(100, Math.round((nextProjectsData.length / denominator) * 100))
          : 100;

        return {
          projects: nextProjects,
          projectsData: nextProjectsData,
          userImages: nextUserImages,
          projectPercentageLoaded,
          displayProjectPercentage: projectPercentageLoaded !== 100,
        };
      });
    } catch (error) {
      // Do nothing
    }
  }

  callSnackbar = (errorType, Body) => {
    this.setState({
      type: errorType,
      message: Body,
    });
    const snackbar = document.getElementById("snackbar-project");
    if (snackbar) {
      snackbar.open = true;
    }
  };

  componentDidUpdate(previousProps, previousState) {
    if (sessionStorage.getItem("selectedtab") !== null) {
      if (previousState.key !== sessionStorage.getItem("selectedtab")) {
        this.setState({ key: sessionStorage.getItem("selectedtab") });
      }
    }
  }

  deleteProject = (e, projectId, projectName) => {
    this.setState({ loadingProjectDelete: true });
    this.setState({ deleteProjectId: projectId });
    this.setState({ deleteProjectName: projectName });
    this.setState({ deleteProjectConfirmPopUpStatus: true });
    apiSession
      .getEMASite(projectId)
      .then((response) => {
        this.setState({ deleteSiteStatus: true });
        this.setState({ emaWebsiteName: response.siteName });
        this.setState({ loadingProjectDelete: false });
      })
      .catch((error) => {
        if (error.response !== undefined) {
        this.setState({ emaWebsiteName: "" });
        this.setState({ loadingProjectDelete: false });
        this.setState({ deleteSiteStatus: false });
        }
      });
    e.stopPropagation();
  };

  copyProject = (e, projectId, projectName) => {
    this.setState({
      copyProjectConfirmPopUpStatus: true,
      copyProjectId: projectId,
      copyProjectName: ``,
      copyProjectSiteName: ``,
    });

    e.stopPropagation();
  };
  removeProjectConfirm() {
    if (this.state.deleteProjectId) {
      if (this.state.projectSite === true) {
        this.deleteEMASite(this.state.deleteProjectId);
      } else {
        this.setState({ loading: true });
        this.removeProject(this.state.deleteProjectId);
      }
    }
    this.closeDeleteProjectPopUp();
  }

  copyProjectConfirm = () => {
    this.setState({ copyProjectConfirmPopUpStatus: false, loading: true });
    const jsonBody = {
      projectId: this.state.copyProjectId,
      projectName: this.state.copyProjectName,
      siteName: this.state.copyProjectSiteName,
    };
    apiSession
      .copyProject(jsonBody)
      .then((json) => {
        sessionStorage.setItem("projectId", json.projectId);
        sessionStorage.setItem("pname", this.state.copyProjectName);
        this.callSnackbar("success", json.message);
        this.setState({ loading: false });
        let { history } = this.props;
        history.push({
          pathname: `${"/information"}/${json.projectId}`,
        });
      })
      .catch((error) => {
        if (error.response !== undefined) {
          this.setState({ loading: false });
          if (parseInt(error.response.status) === 400) {
            this.callSnackbar("error", error.error);
          } else if (error.response.status === 500) {
            this.callSnackbar("error", Error_copy);
          } else {
            this.callSnackbar("error", Error_copy);
          }
        } else {
          this.callSnackbar("error", Error_copy);
        }
      });
  };

  deleteEMASite(projectId) {
    this.setState({ loading: true });
    apiSession
      .deleteEMASite(projectId)
      .then((response) => {
        void this.removeProject(projectId);
        this.setState({ deleteSiteStatus: false });
      })
      .catch((error) => {
        if (error.response !== undefined) {
        this.setState({ loading: false });
        this.setState({ deleteSiteStatus: false });
        if (error.response !== undefined) {
          if (error.response.status === 400) {
            this.callSnackbar("error", error.response.data.message);
          }
        } else {
          this.callSnackbar("error", Error_delete);
        }}
      });
  }

  refreshProjectsAfterDelete = async () => {
    const {
      filtersApplied,
      activePage,
      itemsPerPage,
      totalFilteredCount,
      projectTotalCount,
    } = this.state;

    if (filtersApplied) {
      const nextFilteredCount = Math.max(0, Number(totalFilteredCount || 0) - 1);
      const maxPage = Math.max(1, Math.ceil(nextFilteredCount / itemsPerPage));
      const targetPage = Math.min(activePage, maxPage);

      this.setState({ activePage: targetPage });
      await this.getPageProjects(targetPage);
      return;
    }

    const nextTotalCount = Math.max(0, Number(projectTotalCount || 0) - 1);
    const maxPage = Math.max(1, Math.ceil(nextTotalCount / itemsPerPage));
    const targetPage = Math.min(activePage, maxPage);

    this.setState({ activePage: targetPage });
    await this.getInitialPageProjects(targetPage);
  };

  removeProject = async (projectId) => {
    try {
      await apiSession.deleteProject(projectId);
      this.callSnackbar("success", "Deleted Successfully");
      await this.refreshProjectsAfterDelete();
      this.setState({ loading: false });
    } catch (error) {
      if (error.response !== undefined) {
        this.setState({ loading: false });
        this.callSnackbar("error", "Error in deletion");
      }
    }
  }

  closeDeleteProjectPopUp() {
    this.setState({ deleteProjectId: null });
    this.setState({ deleteProjectName: "" });
    this.setState({ emaWebsiteName: "" });
    this.setState({ deleteProjectConfirmPopUpStatus: false });
    this.setState({ deleteSiteStatus: false });
  }

  closeCopyProjectPopUp = () => {
    this.setState({
      copyProjectConfirmPopUpStatus: false,
      copyProjectId: null,
      copyProjectName: "",
      copyProjectSiteName: "",
    });
  };

  handleCopyProjectChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleProjectSiteChange(e) {
    this.setState({ [e.target.name]: e.target.checked });
  }

  favouriteProject = (e, projectId, favouriteStatus) => {
    this.setState({ loading: true });
    if (favouriteStatus === false) {
      apiSession
        .saveFavourite(projectId)
        .then((response) => {
          this.setState({ loading: false });
          //this.updateFavourites(projectId, true);
          this.loadProject();
          this.callSnackbar("success", "Successfully marked favourite project");
        })
        .catch((error) => {
          if (error.response !== undefined) {
          this.setState({ loading: false });
          this.callSnackbar("error", "Error in marking favourite");
          }
        });
    } else {
      apiSession
        .deleteFavourite(projectId)
        .then((response) => {
          this.setState({ loading: false });
          //this.updateFavourites(projectId, false);
          this.loadProject();
          this.callSnackbar(
            "success",
            "Successfully unmarked favourite project"
          );
        })
        .catch((error) => {
          if (error.response !== undefined) {
          this.setState({ loading: false });
          this.callSnackbar("error", "Error in unmarking favourite");
          }
        });
    }
    e.stopPropagation();
  };

  updateFavourites(projectId, favouriteStatus) {
    let newProjectsData = Object.assign([], this.state.projects);
    newProjectsData.map((data, index) => {
      if (newProjectsData[index].projectId === projectId) {
        newProjectsData[index].favourite = favouriteStatus;
      }
      return null;
    });
    this.setState({ projects: newProjectsData });
    this.setState({ projectsData: newProjectsData });
  }

  getNews() {
    apiSession
      .getNews()
      .then((response) => {
        this.setState({ newsList: [] });
        this.setState({ newsList: response });
      })
      .catch((error) => {
        // Do nothing
      });
  }
  getNotification(){
    apiSession.getNotificationSettings().then((response)=>{
      this.setState({notificationData:response[0]})
      if(response[0]?.enableFlag === true){
        this.setState({notificationShow: true})
      }
    }).catch((error)=>{
      // Do nothing
    })

  }
  onSelectTab(key) {
    sendNavClickEvent('Navigation',TAB_TITLES[key])
    sendPageViewEvent(TAB_TITLES[key])
    this.setState({ key });
    sessionStorage.setItem("selectedtab", key);
    if (key === "projects") {
      this.getNews();
    }
  }

  openOnboard() {
    sendCallToActionEvent("Project","Onboarding","News")
    Onboarding(config);
  }
  closeCreateProjectPopUp = () => {
    this.setState({
      createProjectPopupStatus: false,
      createProject: {
        ...this.state.createProject,
        region: "ANSI",
        application: "Buildings",
        energyManagementSystem: "Microgrid Advisor",
        powerManagementSystem: ""
      },
    });
  };

  onChangeMicrogridType = (e) => {
    const energyMgtSelect = this.state.projectTypes?.[
      e?.target?.value
    ]?.filter((a) => a?.energyManagementSystem === "Microgrid Advisor");
     this.setState({
       createProject: {
         ...this.state.createProject,
         region: e?.target?.value,
         application: "Buildings",
         energyManagementSystem:
           energyMgtSelect?.length > 0
             ? "Microgrid Advisor"
             : energyMgtSelect?.[0]?.energyManagementSystem ??
               "Autogrid Flex",
       },
     });  
 };
  onChangeSubProjectType = (e) => {
    if(e.target.value === "Access to Energy" && this.state.createProject?.region === "IEC"){
      this.setState({
        createProject: {
          ...this.state.createProject,
          application: e.target.value,
          energyManagementSystem: "Microgrid Advisor"
        },
      });
    }else{
      this.setState({
        createProject: {
          ...this.state.createProject,
          application: e.target.value,
        },
      });
    }
   
  };

  onChangeEnergyManagementSystem = (e) => {
    this.setState({
      createProject: {
        ...this.state.createProject,
        energyManagementSystem: e.target.value,
        powerManagementSystem: "EMO-M"
      },
    });
  };

  onChangePowerManagementSystem = (e) => {
    this.setState({
      createProject: {
        ...this.state.createProject,
        powerManagementSystem: e.target.value,
      },
    });
  };

  createProject = async () => {
    if (
      this.state.createProject?.region &&
      this.state.createProject?.application &&
      this.state.createProject?.energyManagementSystem

    ) {
      sendCommonEvent({
        event: 'custom_interaction',
        interaction_name: 'Create Project',
        interaction_location: 'Create Project',
        custom_cde_1:this.state.createProject?.region,
        custom_cde_2:this.state.createProject?.application,
        custom_cde_3:this.state.createProject?.energyManagementSystem
      })
      if(this.state.createProject?.application === "Access to Energy") {
        await this.setState({
          createProject: {
            ...this.state.createProject,
            energyManagementSystem: "Microgrid Advisor",
          },
        },()=>{

        });
      }
      let { history } = this.props;

      const projectType =
        this.state.projectTypes[this.state.createProject?.region]?.filter((item) => {



          return (this.state.createProject?.application === item.application &&
            this.state.createProject?.energyManagementSystem === item.energyManagementSystem)
        })

    if(this.state.createProject?.energyManagementSystem === "New Microgrid Advisor"){
     const projectTypeData = this.state.createProject?.powerManagementSystem ==="EMO-L" ? projectType?.filter((item)=> item.powerManagementSystem === "EMO-L") : projectType?.filter((item)=> item.powerManagementSystem !== "EMO-L")
      if(projectType?.[0]){
      sessionStorage.setItem("projectType", JSON.stringify(projectTypeData?.[0]));
     } 
    }else{
       if(projectType?.[0]){
      sessionStorage.setItem("projectType", JSON.stringify(projectType?.[0]));
     } 
    }
    

     if(projectType?.[0]?.projectTypeValue === "MGaaS AccessToEnergy"){
      sessionStorage.setItem("timeSyncValidate", true);
     }else{
      sessionStorage.setItem("timeSyncValidate", false);
     }
      this.setState({
        createProjectPopupStatus: false,
        createProject: {
          ...this.state.createProject,
          region: "",
          application: "",
          energyManagementSystem: ""
        },
      });

      history.push({
        pathname: "/information/new",
      });
    } else {
      this.callSnackbar("error", "Please Select Values");
    }
  };

  render() {

    return (
      <div>
        <se-container option="centered">
          <div className="container mt-1 mb-1 dark-mode-font-color">
            <Tabs
              id="controlled-tab-example"
              activeKey={this.state.key}
              onSelect={(key) => this.onSelectTab(key)}
            >
              <Tab eventKey="projects" title="PROJECTS">
                {this.state.key === "projects" ? (
                  <div className="container mt-1">
                    {this.state.loading && (
                      <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 99999
                      }}>
                        <se-loading loading={true}></se-loading>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-sm-9 col-md-9 col-lg-9 col-xl-9 se-white-background">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3 px-0 text-right pt-1">
                          <div className="form-row align-items-center justify-content-end">
                            {/* {this.state.displayProjectPercentage && (
                              <div className="col-md-1 d-flex justify-content-center align-items-center">
                              <div
                                style={{
                                  width: 40,
                                  height: 45,
                                  padding: "2px",
                                }}
                                className="d-flex justify-content-center align-items-center"
                              >
                                <CircularProgressbar
                                  value={this.state.projectPercentageLoaded}
                                  text={`${this.state.projectPercentageLoaded}%`}
                                  strokeWidth={10}
                                  styles={{
                                    text: {
                                      fontSize: "28px",
                                    },
                                  }}
                                />
                              </div>
                              </div>
                           )}  */}
                           
                            <input
                              className="form-control  col-md-2 mr-2"
                              type="text"
                              name="searchInput"
                              value={this.state.searchInput}
                              placeholder="Search"
                              onChange={(e) => this.handleSearchInput(e)}
                              aria-label="Search"
                              autoComplete="none"
                            />
                            <select
                              className="form-control col-md-2 mr-2"
                              id="projectTypeFilter"
                              name="projectTypeFilter"
                              value={this.state.projectTypeFilter}
                              onChange={this.onChangeProjectTypeFilter}
                            >
                             <option value="" disabled defaultValue hidden>Project Type</option>
                              <option value="ETO">ETO</option>
                              <option value="IEC">IEC</option>
                              <option value="ANSI">ANSI</option>
                               <option value="all">All</option>
                            </select>
                            <select
                              className="form-control col-md-2 mr-2"
                              id="projectStatusFilter"
                              name="projectStatusFilter"
                              value={this.state.projectStatusFilter}
                              onChange={this.onChangeProjectStatusFilter}
                            >
                              <option value="" disabled defaultValue hidden>Project Status</option>
                              <option value="in_progress">In Progress</option>
                              <option value="completed">Completed</option>
                               <option value="all">All</option>
                            </select>
                            <select
                              className="form-control col-md-2 mr-2"
                              id="exampleFormControlSelect1"
                              name="sortProjectOption"
                              value={this.state.sortProjectOption}
                              onChange={this.onChangeSortOption.bind(this)}
                              style={{
                                display: "inline-flex",
                                  alignItems: "center",
                                  padding:" 6px 14px",
                                  whiteSpace: "nowrap",
                                  boxSizing: "border-box",
                              }}  
                            >
                              <option value="0" selected disabled>Sort</option>
                              <option value="1">Name Asc</option>
                              <option value="2">Name Desc</option>
                              <option value="3">Modification Date Asc</option>
                              <option value="4">Modification Date Desc</option>
                              <option value="5">Favourites</option>
                              </select>
                            {/* <se-button
                              option="raised"
                              color="primary"
                              icon="data_refresh_stroke"
                              onClick={
                                this.state.userScope.access.getUsers ===
                                true
                                  ? this.onResetFilters.bind(this)
                                  : ""
                              }
                              class="col-md-2"
                              disabled={
                                this.state.userScope.access.getUsers ===
                                true
                                  ? false
                                  : true
                              }
                            >
                              { Reset_Filters}
                            </se-button> */}
                             <span
                              className="pointer col-md-1 d-flex justify-content-center align-items-center"
                             
                            >
                              <se-icon className="cheatSheetIcon se-icon icon_button " title="Reset fliters" onClick={this.resetProjectList.bind(this)}>
                                data_refresh
                              </se-icon>
                              {this.state.userScope.role === "SecAdmin" && <se-icon title="Download projects" className="cheatSheetIcon se-icon icon_button "  onClick={this.downloadProjects.bind(this)}>
                                action_download_stroke
                              </se-icon>}
                            </span>
                        
                            <se-button
                              option="raised"
                              color="primary"
                              icon="new_project"
                              onClick={
                                this.state.userScope.access.saveProjects ===
                                true
                                  ? this.onButtonClick.bind(this)
                                  : ""
                              }
                              disabled={
                                this.state.userScope.access.saveProjects ===
                                true
                                  ? false
                                  : true
                              }
                            >
                              {Create_Project}
                            </se-button>
                           
                          </div>
                        </div>

                        {this.state.projects
                          .map((projectData, index) => (
                            <SECard
                              key={projectData.projectId}
                              data={projectData}
                              onCardSelect={this.openProject.bind(
                                this,
                                projectData.projectId,
                                projectData.projectName,
                                projectData.deploymentReady,
                                projectData.projectType
                              )}
                              deleteProjectStatus={
                                this.state.userScope.access.deleteProject ===
                                true
                                  ? true
                                  : false
                              }
                              onDeleteProject={this.deleteProject.bind(this)}
                              onFavouriteProject={this.favouriteProject.bind(
                                this
                              )}
                              userImages={this.state.userImages}
                              copyProjectStatus={
                                this.state.userScope.access.saveProjects
                              }
                              onCopyProject={this.copyProject}
                            />
                          ))}
                        {this.state.projects.length === 0 &&
                        this.state.loading === true ? (
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 border listStyle mb-1 pt-2">
                            <p className="text-center se-font-16px-bold">
                              {Please_Wait}
                            </p>
                          </div>
                        ) : this.state.projects.length === 0 ? (
                          <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 border listStyle mb-1 pt-2">
                            <p className="text-center se-font-16px-bold">
                              No projects available
                            </p>
                          </div>
                        ) : (
                          ""
                        )}

                        <div className="row align-items-center">
                          <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6">
                            {((this.state.filtersApplied && this.state.totalFilteredCount > this.state.itemsPerPage) ||
                              (!this.state.filtersApplied && this.state.projectTotalCount > this.state.itemsPerPage)) ? (
                              <Pagination
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.itemsPerPage}
                                totalItemsCount={this.state.filtersApplied ? this.state.totalFilteredCount : this.state.projectTotalCount}
                                pageRangeDisplayed={5}
                                innerclassName="pagination mt-1 mb-1"
                                onChange={this.handlePageChange.bind(this)}
                                // innerClass="my-pagination"
                                itemClass="page-item"
                                // linkClass="page-link"
                                // activeClass="active-page"
                                // disabledClass="disabled-page"
                              />
                            ) : (
                              ""
                            )}
                          </div>
                          <div
                            style={
                              this.state.projects.length !== 0
                                ? {}
                                : { display: "none" }
                            }
                            className="col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right"
                          >
                            <span>
                              Total Projects : {this.state.filtersApplied ? this.state.totalFilteredCount : this.state.projectTotalCount}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 col-md-3 col-lg-3 col-xl-3">
                        <SENews
                          key={"news"}
                          newsList={this.state.newsList}
                          newsListLength={this.state.newsList.length}
                          onBoardingClick={this.openOnboard.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </Tab>
              {this.state.userScope.access.getUsers === true ? (
                <Tab eventKey="user" title="USER MANAGEMENT">
                  {this.state.key === "user" ? <UserManagement /> : ""}
                </Tab>
              ) : (
                <div></div>
              )}

              {this.state.userScope.access.saveAssets === true ? (
                <Tab eventKey="asset" title="LIBRARY MANAGEMENT">
                  {this.state.key === "asset" ? <LibraryManagementHook /> : ""}
                </Tab>
              ) : (
                <div></div>
              )}

              {this.state.userScope.access.globalParams === true ? (
                <Tab eventKey="globalparam" title="GLOBAL PARAMETERS">
                  {this.state.key === "globalparam" ? (
                    <GlobalParametersHook />
                  ) : (
                    ""
                  )}
                </Tab>
              ) : (
                <div></div>
              )}

              {this.state.userScope.access.audit === true ? (
                <Tab eventKey="analytics" title="ANALYTICS">
                  {this.state.key === "analytics" ? <Analytics /> : null}
                </Tab>
              ) : (
                <div></div>
              )}

              {this.state.userScope.access.dsc === true ? (
                <Tab eventKey="dsc" title="DSC">
                  {this.state.key === "dsc" ? <Dsc /> : ""}
                </Tab>
              ) : (
                <div></div>
              )}
              { this.state.userScope.access.getUsers === true  ? (
                <Tab eventKey="help" title="HELP">
                  {this.state.key === "help"  ? <Help /> : <div></div>}
                </Tab>
              ) : (
                <div></div>
              )}
            </Tabs>
          </div>
          <se-snackbar
            id="snackbar-project"
            type={this.state.type}
            icon="information_stroke"
            message={this.state.message}
            duration="3000"
          ></se-snackbar>

          <se-dialog
            id="dialog-complex-delete-confirm"
            open={this.state.deleteProjectConfirmPopUpStatus}
            can-backdrop="false"
          >
            <se-loading loading={this.state.loadingProjectDelete}></se-loading>
            <se-dialog-header>Confirmation</se-dialog-header>
            <se-dialog-content>
              {this.state.deleteSiteStatus === true ? (
                <span className="se-font-14px">
                  EMA website is running for this project, do you want to delete
                  this EMA website ? If you delete , all site historical data
                  will be lost.
                  <br></br>
                  <br></br>
                  <span className="mt-2">
                    Do you confirm to delete this Project ?
                  </span>
                </span>
              ) : (
                <span className="se-font-14px">
                  <span className="mt-2">
                    Do you want to delete this Project - "
                    <b>{this.state.deleteProjectName}</b>" ?
                  </span>
                  <br></br>
                </span>
              )}

              <br></br>
              <br></br>
              <table className="table table-bordered">
                {this.state.deleteSiteStatus === true ? (
                  <tr>
                    <td>EcoStruxure MicroGrid Advisor(EMA) Website Name</td>
                    <td>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input asCompatible"
                          name="projectSite"
                          id="customControlValidation3"
                          checked={this.state.projectSite}
                          onChange={(e) => this.handleProjectSiteChange(e)}
                        />
                        <label
                          className="custom-control-label line-height-25"
                          htmlFor="customControlValidation3"
                        >
                          <b>{this.state.emaWebsiteName} </b>
                        </label>
                      </div>
                    </td>
                  </tr>
                ) : null}

                {this.state.deleteSiteStatus === true ? (
                  <tr>
                    <td>EcoStruxure MicroGrid Build(EMB) Project Name</td>
                    <td>
                      <div className="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          className="custom-control-input asCompatible"
                          name="projectSite"
                          id="customControlValidation3"
                          checked="true"
                          disabled="true"
                        />
                        <label
                          className="custom-control-label line-height-25"
                          htmlFor="customControlValidation3"
                        >
                          <b>{this.state.deleteProjectName} </b>
                        </label>
                      </div>
                    </td>
                  </tr>
                ) : null}
              </table>
            </se-dialog-content>
            <se-dialog-footer>
              <se-button onClick={this.closeDeleteProjectPopUp.bind(this)}>
                Cancel
              </se-button>
              <se-button onClick={this.removeProjectConfirm.bind(this)}>
                OK
              </se-button>
            </se-dialog-footer>
          </se-dialog>

          <se-dialog
            id="dialog-complex-delete-confirm"
            open={this.state.copyProjectConfirmPopUpStatus}
            can-backdrop="false"
          >
            <se-loading loading={this.state.loadingProjectDelete}></se-loading>
            <se-dialog-header>Copy project</se-dialog-header>
            <se-dialog-content>
              <div className="col-md-12">
                <div className="form-group row mb-0">
                  <label
                    htmlFor="copyProjectName"
                    className="col-sm-9 col-form-label ml-3"
                  >
                    Enter new project name
                  </label>
                </div>
                <div className="form-group">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control form-control-sm"
                      id="copyProjectName"
                      name="copyProjectName"
                      maxLength="50"
                      value={this.state.copyProjectName}
                      onChange={this.handleCopyProjectChange}
                    />
                    <div
                      className="invalid-feedback-custom"
                      style={
                        this.state.copyProjectName ? { display: "none" } : {}
                      }
                    >
                      Project Name is mandatory
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group row mb-0">
                  <label
                    htmlFor="copyProjectSiteName"
                    className="col-sm-9 col-form-label ml-3"
                  >
                    Enter new site name
                  </label>
                </div>
                <div className="form-group mb-0">
                  <div className="col-sm-12">
                    <input
                      type="text"
                      autoComplete="off"
                      className="form-control form-control-sm"
                      id="copyProjectSiteName"
                      name="copyProjectSiteName"
                      maxLength="50"
                      value={this.state.copyProjectSiteName}
                      onChange={this.handleCopyProjectChange}
                    />
                    <div
                      className="invalid-feedback-custom"
                      style={
                        this.state.copyProjectSiteName
                          ? { display: "none" }
                          : {}
                      }
                    >
                      Site Name is mandatory
                    </div>
                  </div>
                </div>
              </div>
              <br></br>
            </se-dialog-content>
            <se-dialog-footer>
              <se-button onClick={this.closeCopyProjectPopUp}>Cancel</se-button>
              <se-button
                onClick={this.copyProjectConfirm}
                disabled={[
                  this.state.copyProjectName,
                  this.state.copyProjectSiteName,
                ].includes("")}
              >
                OK
              </se-button>
            </se-dialog-footer>
          </se-dialog>
          

                <se-dialog
            id="dialog-complex-delete-confirm"
            open={ this.state.notificationShow && sessionStorage.getItem("isNotified") === "false" ? true : false}
            can-backdrop="false"
          >
            <se-dialog-header>Notification</se-dialog-header>
            <se-dialog-content>
             
               {this.state.notificationData?.message}
            </se-dialog-content>
            <se-dialog-footer>
             
              <se-button onClick={()=>{
                sessionStorage.setItem("isNotified",true)
                this.setState({notificationShow: false})
                }}>
                OK
              </se-button>
            </se-dialog-footer>
          </se-dialog>
          
          <se-dialog
            id="dialog-create-project"
            open={this.state.createProjectPopupStatus}
            can-backdrop="false"
            size={this.state.createProject.energyManagementSystem === "New Microgrid Advisor" ?"xlarge":"large"}
          >
            {/* <se-loading loading={this.state.loadingProjectDelete}></se-loading> */}
            <se-dialog-header>Create Project</se-dialog-header>
            <se-dialog-content className="se-dialog-content">
              {Object.keys(this.state.projectTypes).length !== 0 ? (
                <div
                  className="form-group mb-0 px-3 row "
                  // style={{ gap: "10px" }}
                >
                  <div className={`${this.state.createProject.energyManagementSystem === "New Microgrid Advisor"?"form-group col-sm-3 col-md-4 col-xl-3":"form-group col-sm-4"}`}>
                    <span>Select Your Region : </span>
                    <select
                      className="form-control "
                      // style={{ width: "150px" }}
                      id="exampleFormControlSelect1"
                      name="sortProjectOption"
                      value={this.state.createProject.region}
                      onChange={this.onChangeMicrogridType}
                    >
                      {/* <option value="IEC" disabled selected hidden>
                      IEC
                    </option> */}
                      {Object.keys(this.state.projectTypes).map((project) => (
                        <option key={project} value={project}>
                          {project}
                        </option>
                      ))}
                    </select>
                  </div>
                  {this.state.createProject.region && (
                    <div className={`${this.state.createProject.energyManagementSystem === "New Microgrid Advisor"?"form-group col-sm-3 col-md-4 col-xl-3":"form-group col-sm-4"}`}>
                      <span> Choose Application : </span>
                      <select
                        className="form-control "
                        // style={{ width: "150px" }}
                        id="exampleFormControlSelect1"
                        name="sortProjectOption"
                        value={this.state.createProject.application}
                        onChange={this.onChangeSubProjectType}
                      >
                        <option value="Buildings" disabled selected hidden>
                          Buildings
                        </option>
                        {this.state.projectTypes[
                          this.state.createProject.region
                        ]
                          ?.filter((item, index, self) => {
                            return (
                              index ===
                              self.findIndex(
                                (t) => t.application === item.application
                              )
                            );
                          })
                          .map((projectType, index) => (
                            <option
                              key={projectType.application}
                              value={projectType.application}
                              // disabled={projectType.status === "D" ? true : false}
                            >
                              {projectType.application}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}

                  {this.state.createProject.application && (
                    <div className={`${this.state.createProject.energyManagementSystem === "New Microgrid Advisor"?"form-group col-sm-3 col-md-4 col-xl-3":"form-group col-sm-4"}`}>
                      <span> Energy Management System : </span>
                      <select
                        className="form-control  "
                        // style={{ width: "200px" }}
                        id="exampleFormControlSelect1"
                        name="sortProjectOption"
                        value={this.state.createProject.energyManagementSystem}
                        onChange={this.onChangeEnergyManagementSystem}
                      >
                        {/* <option value="Autogrid Flex" disabled selected >
                        Autogrid Flex
                      </option> */}

                        {this.state.projectTypes[
                          this.state.createProject.region
                        ]
                          ?.filter((item, index, self) => {
                            return (
                              item.application ===this.state.createProject.application &&
                              index === self.findIndex(
                                (t) => t.application === item.application && t.energyManagementSystem === item.energyManagementSystem
                              )
                            );
                          })
                          .map((projectType, index) => (
                            <>
                              <option
                                key={projectType.energyManagementSystem}
                                value={projectType.energyManagementSystem}
                                disabled={
                                  projectType.status === "D" ? true : false
                                }
                              >
                                {projectType.energyManagementSystem}
                              </option>
                            </>
                          ))}
                      </select>
                    </div>
                  )}

                  {this.state.createProject.energyManagementSystem === "New Microgrid Advisor" && (
                    <div className="form-group col-sm-3 col-md-4 col-xl-3">
                      <span> Power Management System : </span>
                      <select
                        className="form-control  "
                        // style={{ width: "200px" }}
                        id="exampleFormControlSelect2"
                        name="powerManagementSystem"
                        value={this.state.createProject.powerManagementSystem}
                        onChange={this.onChangePowerManagementSystem}
                      >
                        
                        {this.state.projectTypes[
                          this.state.createProject.region
                        ]
                          ?.filter((item, index, self) => {
                            const itemPMS = item.powerManagementSystem ? item.powerManagementSystem.trim() : "";
                            return (
                              item.application ===
                              this.state.createProject.application &&
                              item.energyManagementSystem ===
                              this.state.createProject.energyManagementSystem &&
                              index ===
                              self.findIndex((t) => {
                                const tPMS = t.powerManagementSystem ? t.powerManagementSystem.trim() : "";
                                return tPMS === itemPMS;
                              })
                            );
                          })
                          .map((projectType, index) => {
                            const trimmedPMS = projectType.powerManagementSystem ? projectType.powerManagementSystem.trim() : "";
                            return (
                              <option
                                key={trimmedPMS || index}
                                value={trimmedPMS}
                              >
                                {trimmedPMS || "None"}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                  )}
                </div>
              ) : (
                <se-loading
                  loading={
                    Object.keys(this.state.projectTypes).length === 0
                      ? true
                      : false
                  }
                ></se-loading>
              )}
            </se-dialog-content>

            <se-dialog-footer>
              <se-button onClick={this.closeCreateProjectPopUp}>
                Cancel
              </se-button>
              <se-button onClick={this.createProject}>OK</se-button>
            </se-dialog-footer>
          </se-dialog>
          <ResetJotai  reset={true}/>
        </se-container>
      </div>
    );
  }
}

export default withRouter(ProjectHome);
